import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { PartyRoomState } from '@/types/PartyRoom'
import RootState from '@/types/RootState'
import SongRequest from '@/types/SongRequest'

export const state: PartyRoomState = {
  partyRoom: undefined,
  queue: new Array<SongRequest>(),
  votesForNextSong: new Array<string>()
}

const namespaced = true

export const partyRoom: Module<PartyRoomState, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
